<script lang="ts" setup>
import supportedVersionsContent from './supportedVersions.md?raw';
import AppMarkdown from 'theme/components/atoms/AppMarkdown.vue';
import SimplePageContainer from 'theme/components/molecules/SimplePageContainer.vue';
import SimplePageHeading from 'theme/components/molecules/SimplePageHeading.vue';
</script>

<template>
  <SimplePageContainer>
    <SimplePageHeading title="推奨環境" />
    <AppMarkdown
      :class="$style.container__content"
      :body="supportedVersionsContent"
    />
  </SimplePageContainer>
</template>

<style lang="scss" module>
.container {
  &__content {
    &:nth-child(n + 2) {
      margin-top: 48px;
    }
  }
}
</style>
